import type { ExperienceManifest } from '../../types'

export const manifest: ExperienceManifest = {
  version: '1.0.0',
  schemaVersion: '1.0.0',
  minimumFrameworkVersion: '1.0.0',
  capabilities: {
    supportsAudio: false,
    supportsInteraction: true,
    supportsReplay: true,
    supportsReducedMotion: true,
    supportsLocalization: false,
    supportsAnalytics: true,
    supportsCelebration: false,
  },
  metadata: {
    id: 'ai-core',
    name: 'Neural AI Core',
    description: 'An interactive synapse network illustrating neural paths and intelligent calculation.',
    category: 'entrance',
    themePreference: 'dark',
  },
  eligibility: {
    check: () => true,
    cooldownMs: 4 * 60 * 60 * 1000,
    basePriority: 55,
  },
  ComponentLoader: () => import('./component'),
  preload: async () => Promise.resolve(),
}

export default manifest
